// extracted by mini-css-extract-plugin
module.exports = {"phoneNum":"antd-pro-components-encryption-phone-index-phoneNum","icon":"antd-pro-components-encryption-phone-index-icon","blue":"antd-pro-components-encryption-phone-index-blue"};